
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.5 14H14.71L14.43 13.73C15.63 12.33 16.25 10.42 15.91 8.39002C15.44 5.61002 13.12 3.39002 10.32 3.05002C6.08999 2.53002 2.53999 6.09001 3.04999 10.32C3.38999 13.12 5.60999 15.44 8.38999 15.91C10.42 16.25 12.33 15.63 13.73 14.43L14 14.71V15.5L18.26 19.75C18.67 20.16 19.33 20.16 19.74 19.75L19.75 19.74C20.16 19.33 20.16 18.67 19.75 18.26L15.5 14ZM9.49999 14C7.00999 14 4.99999 11.99 4.99999 9.50002C4.99999 7.01002 7.00999 5.00002 9.49999 5.00002C11.99 5.00002 14 7.01002 14 9.50002C14 11.99 11.99 14 9.49999 14ZM9.49999 7.00002C9.21999 7.00002 8.99999 7.22002 8.99999 7.50002V9.00002H7.49999C7.21999 9.00002 6.99999 9.22002 6.99999 9.50002C6.99999 9.78002 7.21999 10 7.49999 10H8.99999V11.5C8.99999 11.78 9.21999 12 9.49999 12C9.77999 12 9.99999 11.78 9.99999 11.5V10H11.5C11.78 10 12 9.78002 12 9.50002C12 9.22002 11.78 9.00002 11.5 9.00002H9.99999V7.50002C9.99999 7.22002 9.77999 7.00002 9.49999 7.00002Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-zoom-in`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconZoomIn

    ```js
    <b-new-b-icon-zoom-in />
    ```
</docs>


